// extracted by mini-css-extract-plugin
export default {"container":"wp-z","heading":"xp-z","text":"yp-z","info":"zp-z","link":"Ap-z","fullMaxWidth":"Bp-z"};